<template>
  <div>
    <h3 v-if="!isAnyFormFieldPresent" class="text--disabled text-center">
      No additional configuration required
    </h3>
    <!-- Dynamically handled fields will go here -->
    <v-form v-if="isAnyFormFieldPresent" ref="form" v-model="isFormValid">
      <v-row class="mt-1">
        <v-col v-if="actionEventData.related_statues?.length" cols="12" sm="6">
          <v-autocomplete
            v-model="advanceInfo.action_states"
            :items="actionEventData.related_statues || []"
            label="Action statuses"
            item-text="text"
            item-value="index"
            multiple
            clearable
            outlined
            dense
          />
        </v-col>
        <v-col v-if="actionEventData.related_types?.length" cols="12" sm="6">
          <v-autocomplete
            v-model="advanceInfo.related_types"
            :items="actionEventData.related_types || []"
            label="Action types"
            item-text="text"
            item-value="index"
            multiple
            clearable
            outlined
            dense
          />
        </v-col>
        <v-col
          v-for="field in actionEventData.additional_fields || []"
          :key="field.index"
          cols="12"
          sm="6"
        >
          <v-autocomplete
            v-if="
              field.type === 'dropdown' ||
              field.type === 'dropdown_multi_select'
            "
            v-model="advanceInfo[field.key_name]"
            :items="field.value || []"
            :label="$t(field.label)"
            item-text="text"
            item-value="index"
            clearable
            :rules="[
              (v) =>
                (field.is_required
                  ? v !== null &&
                    v !== undefined &&
                    (Array.isArray(v) ? v.length > 0 : true)
                  : true) || `${$t(field.label)} is required`,
            ]"
            outlined
            :multiple="field.type === 'dropdown_multi_select'"
            dense
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "StepAdvanced",
  props: {
    value: Object,
    valid: Boolean,
    actionEvent: [String, Number],
  },
  data() {
    return {
      isFormValid: true,
      advanceInfo: {
        action_states: (this.value && this.value.action_states) || [],
        related_types: (this.value && this.value.related_types) || [],
      },
    };
  },
  computed: {
    serverData() {
      return this.$store.getters.getWEBHOOKSActionsDialogServerData || {};
    },
    actionEventData() {
      return (
        this.serverData.action_event_data?.find(
          (event) => event.index === this.actionEvent
        ) || {}
      );
    },
    isAnyFormFieldPresent() {
      return (
        (this.actionEventData.related_statues || []).length > 0 ||
        (this.actionEventData.related_types || []).length > 0 ||
        (this.actionEventData.additional_fields || []).length > 0
      );
    },
  },
  methods: {
    handleSubmit() {
      // trigger local form validation and emit selected advanced fields
      this.validateForm();
      if (this.isFormValid) {
        this.$emit("submit", {
          ...this.advanceInfo,
        });
      }
    },
    initAdditionalValues(fields = []) {
      fields.forEach((f) => {
        if (!f || !f.key_name) return;
        // if not already present, set to null (or existing value)
        if (!(f.key_name in this.advanceInfo)) {
          if (this.$set) this.$set(this.advanceInfo, f.key_name, null);
          else this.advanceInfo[f.key_name] = null;
        }
      });
    },
    clearActionStatuses() {
      this.advanceInfo.action_states = [];
    },
    reset() {
      this.advanceInfo = {
        action_states: [],
        related_types: [],
      };
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetValidation();
      });
    },
    validateForm() {
      this.$refs.form && this.$refs.form.validate();
      return this.isFormValid;
    },
    getAdvanceInfo() {
      return { ...(this.advanceInfo || {}) };
    },
  },

  watch: {
    value: {
      handler(newVal) {
        // sync incoming prop into local copy for edit mode
        // console.log("Incoming Value:", newVal);
        this.advanceInfo = newVal;
        // console.log("Advance Info:", this.advanceInfo);
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped></style>
